import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useAdminArticleStore } from '@features/admin/articles/useAdminArticleStore.ts';
import ArticlesPage from '@features/admin/articles/ArticlesPage.tsx';

const adminArticlesSearchSchema = z.object({
  q: z.string().optional(),
  targetType: z.enum(['ALL', 'BY_SUPPLIER', 'BY_PRODUCT']).optional(),
  isUrgent: z.coerce.boolean().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminArticlesSearch = z.infer<typeof adminArticlesSearchSchema>;

export const Route = createFileRoute('/admin/articles/')({
  validateSearch: search => adminArticlesSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { q, targetType, isUrgent, page, size } = ctx.search;
    useAdminArticleStore.getState().loadArticles({
      q,
      targetType,
      isUrgent,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <ArticlesPage />;
}
